import React from 'react';
import { useAuthStore } from '@/common/stores/authStore';
import Header from './Header';
import Sidebar from './Sidebar';
import './RootLayout.css';

interface RootLayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
}

const RootLayout: React.FC<RootLayoutProps> = ({ children, showSidebar = true }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <div className="root-layout">
      {isAuthenticated ? (
        <>
          {showSidebar && <Sidebar />}
          <main className={`root-layout__main ${showSidebar ? 'root-layout__main--with-sidebar' : ''}`}>
            {children}
          </main>
        </>
      ) : (
        <>
          <Header />
          <main className="root-layout__main">{children}</main>
        </>
      )}
    </div>
  );
};

export default RootLayout;
